import { useUser } from "@services/UserContext";
import React, { useEffect, useState } from "react";

interface HeaderProps {
  chatScope: string;
}

const Header: React.FC<HeaderProps> = ({ chatScope }) => {
  const [visible, setVisible] = useState(false);
  const { user } = useUser();

  useEffect(() => {
    setVisible(false);

    const timeout = setTimeout(() => {
      setVisible(true);
    }, 50);

    return () => clearTimeout(timeout);
  }, [chatScope]);

  const getScopeContent = () => {
    if (chatScope.startsWith("Files:")) {
      const fileListRaw = chatScope.replace("Files:", "").trim();
      const files = fileListRaw.split(",").map((f) => f.trim());

      if (files.length === 1) {
        return <span className="text-blue-600">{files[0]}</span>;
      }

      return (
        <span className="relative group text-blue-600 cursor-pointer">
          <span className="underline">Files</span>
          <div className="absolute z-10 bottom-full mb-3 hidden text-start group-hover:block text-white bg-gray-800 shadow-lg border border-gray-300 rounded-md text-sm p-2 w-max max-w-xs whitespace-pre-wrap mt-2 left-1/2 -translate-x-1/2">
            <ul className="list-disc pl-6 space-y-2 py-1">
              {files.map((file, idx) => (
                <li key={idx}>{file}</li>
              ))}
            </ul>
          </div>
        </span>
      );
    }

    // Default fallback for any other scope
    return <span className="text-blue-600">{chatScope}</span>;
  };

  return (
    <div className="items-center justify-between text-black rounded-t-lg">
      <h2
        className={`
          text-base 2xl:text-lg text-center pb-2 
          transition-all duration-500 ease-out
          ${visible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-5"}
        `}
      >
        {chatScope === "Global" ? (
          <span>How can I help, {user?.first_name ?? "user"}?</span>
        ) : (
          <>
            <span>Answering questions about </span>
            {getScopeContent()}
          </>
        )}
      </h2>
    </div>
  );
};

export default Header;
